import {Api,handleResponse,handleError} from '../../../../../../api';
//Action
const Actions = {
    GetFiles: 'partner/get-tender-files',
    DownloadFile:'partner/download-tender-file',
    DownloadAllFiles:'partner/download-all-tender-files'
}


export const apiRequest = {
    getFiles,
    downloadFile,
    downloadAllFile
};

async function getFiles(parent,model) {
    await new Api().call.post(Actions.GetFiles,model).then(handleResponse)
        .then(res => {
            parent.setState((prevState)=>({
                items:res,
                loading:false
            }));
        }).catch(handleError);
}

async function downloadFile(parent,partnerId,tenderId,fileId,isFolder) {

    parent.setState({
        downloadIsProgress:fileId
    });
        await new Api().call.post(`${Actions.DownloadFile}/${partnerId}/${tenderId}/${fileId}/${isFolder}`,null,{
            onDownloadProgress: progressEvent => {
                const {loaded,total} = progressEvent;
            
                let percent = Math.floor(loaded / total * 100)
            //console.log(`${loaded}kb of ${total}kb | ${percent}%`);
            },
            responseType: 'arraybuffer'
        })
        .then(res => {
            var blob = new Blob([res.data], {type: "application/octet-stream"});
            var header = res.headers['content-disposition'];
            //Get file name from header
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(header);
            let fileName;
            if (matches != null && matches[1]) { 
                fileName = matches[1].replace(/['"]/g, '');
            }
             //Create the download link
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();

            parent.setState({
                    downloadIsProgress:null
            });
            
        }).catch(error=>{
            handleError(error);
            let response = {message:'Váratlan hiba miatt nem tölthető le',type:'error'}
            if(error.response!==null && error.response!==undefined && error.response.data!==null && error.response.data!==undefined){
                var decodedString = String.fromCharCode.apply(null, new Uint8Array(error.response.data));
                var obj = JSON.parse(decode_utf8(decodedString));
                if(obj!==null && obj!==undefined){
                    response = obj;
                }
            }
            parent.setState({
                     downloadIsProgress:null,
                     requestResponse: response
             });
        });
    
}

async function downloadAllFile(parent,partnerId,tenderId,parentId) {


    parent.setState({
        zipIsProgress:true
    });

    await new Api().call.post(`${Actions.DownloadAllFiles}/${partnerId}/${tenderId}/${parentId}`,null,{
        onDownloadProgress: progressEvent => {
            const {loaded,total} = progressEvent;
        
            let percent = Math.floor(loaded / total * 100)
        //console.log(`${loaded}kb of ${total}kb | ${percent}%`);
        },
        responseType: 'arraybuffer'

    }).then(res => {       
            var blob = new Blob([res.data], {type: "application/octet-stream"});
            var header = res.headers['content-disposition'];
            //Get file name from header
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(header);
            let fileName;
            if (matches != null && matches[1]) { 
                  fileName = matches[1].replace(/['"]/g, '');
            }
            //Create the download link
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();

            parent.setState({
                zipIsProgress:false
            });

        }).catch(error=>{
            handleError(error);
            let response = {message:'Váratlan hiba miatt nem tölthető le',type:'error'}
            if(error.response!==null && error.response!==undefined && error.response.data!==null && error.response.data!==undefined){
                var decodedString = String.fromCharCode.apply(null, new Uint8Array(error.response.data));
                var obj = JSON.parse(decode_utf8(decodedString));
                if(obj!==null && obj!==undefined){
                    response = obj;
                }
            }
            parent.setState({
                     requestResponse: response,
                     zipIsProgress:false
             });
        });
    
}


function decode_utf8(utftext) {
    var plaintext = ""; var i=0; 
    var c=0;
    var c1=0;
    var c2=0;
    var c3=0;
    // while-Schleife, weil einige Zeichen uebersprungen werden
    while(i<utftext.length)
        {
        c = utftext.charCodeAt(i);
        if (c<128) {
            plaintext += String.fromCharCode(c);
            i++;}
        else if((c>191) && (c<224)) {
            c2 = utftext.charCodeAt(i+1);
            plaintext += String.fromCharCode(((c&31)<<6) | (c2&63));
            i+=2;}
        else {
            c2 = utftext.charCodeAt(i+1); c3 = utftext.charCodeAt(i+2);
            plaintext += String.fromCharCode(((c&15)<<12) | ((c2&63)<<6) | (c3&63));
            i+=3;}
        }
    return plaintext;
}	

